import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import "./EditRecordingFunctionality.html";

import EditRecordingFunctionalityComponentController from "./EditRecordingFunctionalityComponentController";

export default class EditRecordingFunctionalityComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    public transclude: boolean;

    constructor() {
        this.bindings = {
            resolve: "<",
        };
        this.controller = EditRecordingFunctionalityComponentController;

        // tslint:disable:max-line-length
        this.templateUrl =
            "/App/Components/Site/DesignAndPlanning/SelectedEquipment/CameraConfigurations/EditRecordingFunctionality/EditRecordingFunctionality.html";

        this.transclude = true;
    }
}

module("mmManagePortal").component("irEditRecordingFunctionality", new EditRecordingFunctionalityComponent());
